module.exports = __webpack_public_path__ + "img/00-menu-bar-off_01.4c1ac911.png";